export default __webpack_public_path__ + "static/media/army_71.1702d508.jpg";